<div  class="page_header mt-20">
  <h6 *ngIf="!isEd" class="heading">Account Number :{{carrierAccNumber}}| Account Name :{{carrierNames}} |Carrier Type:{{carrierType}}</h6>
</div>
<br>
<div class="stepper-header col-3">
  <div class="row" (click)="jumpToPermit()" style="cursor: pointer;">
    <div class="col-4 step-one" >
      1. Permit Information
    </div>
    <div class="circle" [style.background-color]="background1">
      <img src="../../assets/stepper-img/done-56@2x.png" *ngIf="!isProgress1" height="10" />
      <span style="color: transparent;" *ngIf="isProgress1">1</span>
    </div>
    <div>

    </div>

  </div>
  <div class="row" (click)="jumpToVehicle()" style="cursor: pointer;">
    <div class="col-4 step-two">
      2. Vehicle
    </div>
    <div class="circle" [style.background-color]="background2">
      <img src="../../assets/stepper-img/done-56@2x.png" *ngIf="isProgress2" height="10" />
      <span style="color: transparent;" *ngIf="!isProgress2">2</span>
    </div>
    <div>
    </div>

  </div>
  <div class="row" (click)="jumpToRoutes()" style="cursor: pointer;">
    <div class="col-4 step-three">
      3. Routes
    </div>
    <div class="circle" [style.background-color]="background3">
      <img src="../../assets/stepper-img/done-56@2x.png" *ngIf="isProgress3" height="10" />
      <span style="color: transparent;" *ngIf="!isProgress3">3</span>
    </div>
    <div>
    </div>

  </div>
  <div class="row" (click)="jumpToMotivation()" style="cursor: pointer;">
    <div class="col-4 step-four" >
      4. Motivation
    </div>
    <div class="circle" [style.background-color]="background4">
      <img src="../../assets/stepper-img/done-56@2x.png" *ngIf="isProgress4" height="10" />
      <span style="color: transparent;" *ngIf="!isProgress4">4</span>
    </div>
    <div>
    </div>

  </div>
  <div class="row" *ngIf="utility.timetableActive" (click)="jumpToTimetables()" style="cursor: pointer;">
    <div class="col-4 step-five">
      5. Timetable
    </div>
    <div class="circle" [style.background-color]="background5">
      <img src="../../assets/stepper-img/done-56@2x.png" *ngIf="isProgress5" height="10" />
      <span style="color: transparent;" *ngIf="!isProgress5">5</span>
    </div>
    <div>
    </div>

  </div>
  <div class="row" *ngIf="!utility.timetableActive" (click)="jumpToUploads()" style="cursor: pointer;">
    <div class="col-4 step-five" >
      5. Documents
    </div>
    <div class="circle" [style.background-color]="background5">
      <img src="../../assets/stepper-img/done-56@2x.png" *ngIf="isProgress5" height="10" />
      <span style="color: transparent;" *ngIf="!isProgress5">5</span>
    </div>
    <div>
    </div>

  </div>
  <div class="row" *ngIf="utility.timetableActive" (click)="jumpToUploads()" style="cursor: pointer;">
    <div class="col-4 step-six">
      6. Documents
    </div>
    <div class="circle" [style.background-color]="background6">
      <img src="../../assets/stepper-img/done-56@2x.png" *ngIf="isProgress6" height="10" />
      <span style="color: transparent;" *ngIf="!isProgress6">5</span>
    </div>
    <div>
    </div>

  </div>

  <div class="row" *ngIf="!utility.timetableActive" (click)="jumpToReview()" style="cursor: pointer;">
    <div class="col-4 step-six">
      6. Review
    </div>
    <div class="circle last" [style.background-color]="background6">
      <img src="../../assets/stepper-img/done-56@2x.png" *ngIf="isProgress6" height="10" />
      <span style="color: transparent;" *ngIf="!isProgress6">6</span>
    </div>
    <div>
    </div>
  </div>
  <div class="row" *ngIf="utility.timetableActive" (click)="jumpToReview()" style="cursor: pointer;">
    <div class="col-4 step-seven">
      7. Review
    </div>
    <div class="circle last" [style.background-color]="background7">
      <img src="../../assets/stepper-img/done-56@2x.png" *ngIf="isProgress7" height="10" />
      <span style="color: transparent;" *ngIf="!isProgress7">6</span>
    </div>
    <div>
    </div>
  </div>
</div>
<div class="stepper-content col-9">

  <div style="width: 70%;" *ngIf="isProgress1">
    <app-app-permit-type [dataCntrl]="dataCntrl" (nextStep)="next($event)"></app-app-permit-type>
    <button type="button" class="btn btn-secondary btn-sm" (click)="next(1)" id="permit-stepper"
      style="display: none;">Next</button>

  </div>

  <div style="width: 80%;" *ngIf="isStepper2">
    <app-app-vehicle [dataCntrl]="dataCntrl" (previousStep)=(previous($event))  (nextStep)="next($event)"></app-app-vehicle>
    <button type="button" class="btn btn-primary btn-sm" (click)="previous(2)" id="vehicle-stepper-prev"
      style="display: none;">Prev</button>
    <button type="button" class="btn btn-secondary btn-sm" (click)="next(2)" id="vehicle-stepper-next"
      style="display: none;">Next</button>



  </div>
  <div style="width: 100%;" *ngIf="isStepper3">
    <app-app-route *ngIf="!isDigitalRoute" [dataCntrl]="dataCntrl" (previousStep)=(previous($event))  (nextStep)=next($event) (tryOutDigitalRoutes)="setRoute($event)"></app-app-route>
 <ng-container *ngIf="isDigitalRoute">
   <app-ext-route-list [dataCntrl]="dataCntrl" (previousStep)=(previous($event))  (nextStep)=next($event) (tryOutTextRoutes)="setRoute($event)"></app-ext-route-list>


<!--   <button title="Cancel" *ngIf="!isView"  (click)="cancelApplication()" type="submit" class="btn hd-btn-close">-->
<!--     Close-->
<!--   </button>-->
<!--   <button *ngIf="!isView"  (click)="previous(3)" type="submit" class="btn  hd-btn">-->
<!--     Back-->
<!--   </button>-->
<!--   <button *ngIf="!isView"  (click)="gotoMotivation()" type="submit" class="btn  hd-btn">-->
<!--     Next-->
<!--   </button>-->
<!--     <br/>-->
 </ng-container>
    <button type="button" class="btn btn-primary btn-sm" style="display: none" (click)="previous(3)" id="route-stepper-prev">Prev</button>
    <button type="button" class="btn btn-secondary btn-sm" style="display: none" (click)="next(3)" id="route-stepper-next">Next</button>

  </div>
  <div style="width: 100%;" *ngIf="isStepper4">
    <app-app-motivation [dataCntrl]="dataCntrl" (previousStep)=(previous($event)) (nextStep)=next($event)></app-app-motivation>

    <button type="button" class="btn btn-primary btn-sm" (click)="previous(4)" id="motivation-stepper-prev"
      style="display: none;">Prev</button>
    <button type="button" class="btn btn-secondary btn-sm" (click)="next(4)" id="motivation-stepper-next"
      style="display: none;">Next</button>

  </div>
  <div style="width: 100%;" *ngIf="isStepper5 && utility.timetableActive">
  <app-permit-timetable [dataCntrl]="dataCntrl" (previousStep)=(previous($event)) (nextStep)=next($event)></app-permit-timetable>
    <button type="button" class="btn btn-primary btn-sm" (click)="previous(5)" id="timetable-stepper-prev"
      style="display: none;">Prev</button>
    <button type="button" class="btn btn-secondary btn-sm" (click)="next(5)" id="timetable-stepper-next"
      style="display: none;">Next</button>
  </div>
  <div style="width: 85%;" *ngIf="isStepper5 && !utility.timetableActive">
    <app-app-uploads isPermitDoc="true" [dataCntrl]="dataCntrl"  (previousStep)=(previous($event)) [isTimeTableActive] ="false" (nextStep)=next($event) [hideEdits]="true"></app-app-uploads>
    <button type="button" class="btn btn-primary btn-sm"  (click)="previous(5)" id="uploads-stepper-prev"
      style="display: none;">Prev</button>
    <button type="button" class="btn btn-secondary btn-sm" (click)="next(5)" id="uploads-stepper-next"
      style="display: none;">Next</button>

  </div>
  <div style="width: 85%;" *ngIf="isStepper6 && utility.timetableActive">
    <app-app-uploads isPermitDoc="true" [dataCntrl]="dataCntrl" [isTimeTableActive]="true" (previousStep)=(previous($event)) (nextStep)=next($event) [hideEdits]="true"></app-app-uploads>
    <button type="button" class="btn btn-primary btn-sm" (click)="previous(6)" id="uploads1-stepper-prev"
      style="display: none;">Prev</button>
    <button type="button" class="btn btn-secondary btn-sm" (click)="next(6)" id="uploads1-stepper-next"
      style="display: none;">Next</button>

  </div>

  <div style="width: 85%;" *ngIf="isStepper6 && !utility.timetableActive">
    <app-confirmation [dataCntrl]="dataCntrl" [stepper]="6" [isTimeTableActive]="false" (previousStep)=(previous($event)) ></app-confirmation>
    <button type="button" class="btn btn-primary btn-sm" (click)="previous(6)" id="con-stepper-prev"
      style="display: none;">Prev</button>
    <!-- <button type="button" class="btn btn-secondary btn-sm" (click)="next(6)" id="confirmation-stepper-next" style="display: none;">Done</button> -->

  </div>
  <div style="width: 100%;" *ngIf="isStepper7 && utility.timetableActive">
    <app-confirmation [dataCntrl]="dataCntrl" [stepper]="7" [isTimeTableActive]="true" (previousStep)=(previous($event))></app-confirmation>
    <button type="button" class="btn btn-primary btn-sm" (click)="previous(7)" id="con1-stepper-prev"
      style="display: none;">Prev</button>
    <!-- <button type="button" class="btn btn-secondary btn-sm" (click)="next(7)" id="confirmation1-stepper-next" style="display: none;">Done</button> -->
  </div>
</div>
